import { useContext } from 'react';
import { UserContext, UserProfile, LoginType, KaEmployeeProfile } from './UserContext';

export const useUserOrKaEmployee = (): UserProfile | KaEmployeeProfile => {
  const { user } = useContext(UserContext);

  if (user?.userType === LoginType.User) {
    return user as UserProfile;
  }

  if (user?.userType === LoginType.KaEmployee) {
    return user as KaEmployeeProfile;
  }

  throw new Error("useUserOrKaEmployee hook can only be used inside of components contained inside an UserTemplate or a KaEmployeeTemplate component");
}